<div class="calendar-component">
  <mat-toolbar>
    <mat-toolbar-row class="calendar-toolbar action-toolbar">
      <div class="left-column"></div>
      <div class="middle-column"></div>
      <div class="right-column">
        <ws-searchbar
          [config]="reservationSearchConfig"
          [searchFunction]="searchReservations"
          [resultMapper]="mapReservationForDisplay"
          (submit)="onSearchSubmit($event)"
          (openStateToggled)="onSearchToggle($event)"
          (resultSelected)="onReservationSelected($event)">
        </ws-searchbar>
        <ws-button (click)="todayClicked()" *ngIf="view === 'calendar'">
          {{ "Today" | translate }}
        </ws-button>
        <ws-datepicker [selectedDate]="selectedDate" (dateSelected)="onDateChange($event)" *ngIf="view === 'calendar'"
          tooltip="{{ 'Pick a Date' | translate }}">
        </ws-datepicker>
        <ws-period-navigator [period]="period" (decrementClicked)="decrementDateClicked()"
          (incrementClicked)="incrementDateClicked()" *ngIf="view === 'calendar'"></ws-period-navigator>
        <ws-selector (selectedChange)="viewChangedNew($event)" [options]="calendarViews" [selectedId]="currentViewMode"
          [formatter]="formatView" tooltip="{{ 'Select your calendar view' | translate }}"></ws-selector>

        <ws-actions [options]="actionsAdd" (clickOnAction)="actionAddSelected($event)" [callToActionType]="'primary'"
          tooltip="{{ 'Select an action' | translate }}" icon="add" [text]="'Add' | translate">
        </ws-actions>
        <ws-selector [options]="optionsStatus" (selectedItemsChange)="optionsStatusChanged($event)" [formatter]="formatView"
          [multiSelect]="true" [fixedText]="'Statuses' | translate" [selectedItems]="getArrayStatusFilter()"
          tooltip="{{ 'Select the filtered status' | translate }}"></ws-selector>
        <ws-button (click)="openFilterDialog()" *ngIf="view === 'list'" [matBadge]="appliedFilters | keycount"
          [tooltip]="'Filter' | translate">
          <mat-icon>filter_alt</mat-icon>
        </ws-button>
        <div *ngIf="calendarExportAllowed()" [wsTooltip]="isExportDisabled() ? getExportTooltip() : ''" [wsTooltipDisabled]="!isExportDisabled()">
          <ws-actions (clickOnAction)="openExportDialog($event)" [options]="exportOptions" [tooltip]="!isExportDisabled() ? getExportTooltip() : ''" [disabled]="this.totalElements === 0 || this.isExporting" icon="download"></ws-actions>
        </div>
        <ws-actions [options]="actions" (clickOnAction)="actionSelected($event)" *ngIf="view === 'calendar'"
          tooltip="{{ 'Select an action' | translate }}" icon="settings">
        </ws-actions>
      </div>
    </mat-toolbar-row>
  </mat-toolbar>

  <div class="scrollbar-overflow" style="border-radius: 15px;">
    <div class="calendar-wrapper" dwsPermission="CALENDAR" dwsPermissionDenyMode="hide">
      <div [ngClass]="{
        'calendar-day-view': calendarView == 'day',
        'split-view': splitView
      }" class="calendar-content">
        <div *ngIf="view === 'calendar'">
          <app-reservation-calendar (eventClick)="eventClicked($event)" (periodChange)="periodSelected($event)"
            [calendarConfiguration]="calendarConfiguration" [calendarSchedulingEvents]="calendarSchedulingEvents"
            [date]="selectedDate" [ngClass]="{ 'reservation-opened': selectedReservation != null }" [view]="calendarView">
          </app-reservation-calendar>
        </div>
        <div *ngIf="view === 'list'">
          <app-reservation-list (reservationFilterEvent)="reservationFilter($event)"
            (winerySchedulingClick)="winerySchedulingClicked($event)"
            (totalElementsChange)="onTotalElementsChange($event)"
            [defaultFilters]="statusFilter">
          </app-reservation-list>
        </div>
        <app-reservation-detail (closeClick)="selectedReservation = undefined"
          (reservationUpdated)="onReservationDetailUpdated($event)"
          *ngIf="calendarView == 'day' && selectedReservation"
          [ngClass]="{ 'reservation-opened': selectedReservation != null }"
          [reservationId]="selectedReservation.id"></app-reservation-detail>
        <web-appointment-detail (closeClick)="selectedAppointment = undefined"
          *ngIf="calendarView == 'day' && selectedAppointment" [appointment]="selectedAppointment"
          [ngClass]="{ 'appointment-opened': selectedReservation != null }">
        </web-appointment-detail>
        <app-grouped-reservations-detail (addClick)="addGroupedClicked()"
          (closeClick)="selectedReservationGroup = undefined" (detailsClick)="detailsGroupedClicked($event)"
          *ngIf="calendarView == 'day' && selectedReservationGroup" [employees]="employees"
          [reservation]="selectedReservationGroup" [rooms]="rooms" class="noHeightLimit"
          style="border-radius: 15px"></app-grouped-reservations-detail>

      <!-- <div
        *ngIf="calendarView == 'day' && !selectedReservation"
        class="no-event-selected"
      >
        <span>{{ "No event selected" | translate }}</span>
      </div> -->
    </div>
  </div>
</div>
